/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
const timestampToTime = (timestamp) => {
    let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M =
        (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1) + '-'
    let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    let h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    let m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
    let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return Y + M + D + h + m + s
};
const organizationName = "中国航油集团重庆石油有限公司";
const questionTypeList = [
    { label: '单选题', id: 1 },
    { label: '多选题', id: 2 },
    { label: '判断题', id: 3 }
];
/**
 * 存储localStorage
 */
const setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
const getStore = name => {
    if (!name) return;
    return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
const removeStore = name => {
    if (!name) return;
    window.localStorage.removeItem(name);
}

/**
 * 设置cookie
 **/
function setCookie (name, value, day) {
    let date = new Date();
    date.setDate(date.getDate() + day);
    document.cookie = name + '=' + value + ';expires=' + date;
};

/**
 * 获取cookie
 **/
function getCookie (name) {
    let reg = RegExp(name + '=([^;]+)');
    let arr = document.cookie.match(reg);
    if (arr) {
        return arr[1];
    } else {
        return '';
    }
};

/**
 * 删除cookie
 **/
function delCookie (name) {
    setCookie(name, null, -1);
};
const flatten = arr => {
    return [].concat(...arr.map(item => {
        if (item.children) {
            const arr = [].concat(item, ...flatten(item.children));
            delete item.children;
            return arr;
        }
        return [].concat(item);
    }
    ));
};
const capitalEnglishList = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
const fileDownload = (url, name) => {
    const nowA = document.createElement('a');
    nowA.setAttribute('href', url);
    nowA.setAttribute('download', name);
    nowA.style.display = 'none';
    document.body.appendChild(nowA);
    nowA.click();
    document.body.removeChild(nowA);
};
// 文件流转blob对象下载
function downloadFile (data, type, fileName) {
    const blob = new Blob([data], { type: `application/${type};charset=utf-8` });
    const downloadElement = document.createElement('a');
    const href = window.URL.createObjectURL(blob);
    downloadElement.href = href;

    downloadElement.download = fileName;
    downloadElement.click();
    window.URL.revokeObjectURL(href);
}
/**
 * @param no 接收的字符串（手机号/身份证号）
 * @param start 脱敏起始位置
 * @param end 脱敏结束位置（倒数位置）
 * @param replace 脱敏个数
 * @param split 脱敏标识
 * @returns 脱敏后的字符串
 */
const numberDesensitization = (no = '', start = 3, end = 2, replace = 0, split = '*') => {
    if (!no) return no
    const toStr = no.toString()
    let targetStr = ''
    const rules = new RegExp(`(\\d{${start}})\\d*(\\d{${end}})`) // 根据首尾脱敏
    const rulesReplace = new RegExp(`(\\d{${start}})\\d{${replace}}(\\d*)`)  // 根据开始位置和脱敏个数脱敏
    for (let i = 0; i < toStr.length; i++) {
        if (
            (replace && i > Number(start) && i <= Number(start) + Number(replace)) ||
            (!replace && i > Number(start) && i <= toStr.length - Number(end))
        )
            targetStr += split
    }
    return toStr.replace(replace ? rulesReplace : rules, `$1${targetStr}$2`)
}


export {
    timestampToTime,
    setStore,
    getStore,
    removeStore,
    setCookie,
    getCookie,
    delCookie,
    flatten,
    capitalEnglishList,
    fileDownload,
    downloadFile,
    organizationName,
    questionTypeList,
    numberDesensitization
}


// WEBPACK FOOTER //
// ./src/utils/util.js